import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Help from '@material-ui/icons/Help';
import Zoom from '@material-ui/core/Zoom';
import Tooltip from '@material-ui/core/Tooltip';

import {HelpActivatedContext} from '../../Context'


const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(4),
    left: theme.spacing(4),
    width: 42,
    height: 42,
    minHeight: 'unset',
    zIndex: 1000

  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));



// Example usage in a parent component
export const PrescriptionDashboard = () => {

    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)

    console.log(helpActivatedTooltips)
    
    const FloatingActionButton = ({ onClick, tooltipTitle = "Πατήστε το κουμπί για να ενεργοποιήσετε/απενεργοποιήσετε τα μηνύματα βοήθειας. Εμφανίζονται όταν τοποθετείτε τον κέρσορα πάνω από τα πεδία." }) => {
        const classes = useStyles();
        const [isHovered, setIsHovered] = useState(false);
      
        return (
          <Zoom in={true} timeout={500} unmountOnExit>
            <Tooltip title={tooltipTitle} placement="left" arrow>
              <Fab
                color={!helpActivatedTooltips ? "primary" : "default"}
                aria-label={tooltipTitle}
                className={classes.fab}
                onClick={onClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Help />
              </Fab>
            </Tooltip>
          </Zoom>
        );
    };


    const handleNewPrescription = () => {
    
        
        setHelpActivatedTooltips(prev=>!prev)
    
    };

  return (
    <div>
      {/* Your other dashboard components */}
      <FloatingActionButton onClick={handleNewPrescription} />
    </div>
  );
};

